import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  editProperty,
  propertyFormUpdate,
} from "reduxStore/action/propertyActions";
import strings from "translate/language";
import { isEmpty, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";
import moment from "moment";
import Input from "component/Input";

const EditPropertyStepFourth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { property_id = "" } = params || {};
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const [formState, setFormState] = useState({});

  const [marketingAI, setMarketingAI] = useState({
    hoardings: "",
    newspaper: "",
    whatsapp_sms: "",
    blast_radio_jingles: "",
    digital_marketing: {
      digital_marketing_google: 0,
      digital_marketing_facebook: 0,
      digital_marketing_instagram: 0,
      digital_marketing_taboola: 0,
      digital_marketing_timeSquare: 0,
    },
  });
  const [marketingBD, setMarketingBD] = useState({
    resident_location: "",
    office_location: "",
    occupation: "",
    customer_designation: "",
    annual_income: "",
    ethnicity: "",
    age_group: "",
    rented_owned: "",
    current_stay_configuration: "",
    customer_budget: "",
    preferred_typology: "",
    purpose_of_purchase: "",
    possessionexpected: "",
  });

  const propertyFormSelector = useSelector((state) => state.propertyForm) || {};
  const propertySelector = useSelector((state) => state.propertyData);

  const handledigitalmarketing = (e) => {
    const nextMarketingAI = {
      ...marketingAI,
      digital_marketing: {
        ...marketingAI?.digital_marketing,
        [e.target.name]: e.target.checked === true ? 1 : 0,
      },
    };
    setMarketingAI(nextMarketingAI);
  };
  const handleInputFieldBDS = (e) => {
    const nextmarketingBD = {
      ...marketingBD,
      [e.target.name]: e.target.value,
    };
    setMarketingBD(nextmarketingBD);
  };
  useEffect(() => {
    if (propertySelector?.create) {
      if (propertySelector?.response?.status === 200) {
        dispatch(propertyFormUpdate(null));
        navigatpage("/Property");
      }
    }
  }, [propertySelector]);
  useLayoutEffect(() => {
    const { update, response } = propertyFormSelector;
    if (update && response) {
      setFormState({
        ...response,
        ...response.property_customer_profile,
      });
      let typeofAI = typeof response?.marketing_assistance_information;
      if (typeofAI === "string" || typeofAI === "object") {
        setMarketingAI(
          typeofAI === "object"
            ? response?.marketing_assistance_information
            : JSON.parse(response?.marketing_assistance_information)
        );
      }
      let typeofBD = typeof response?.marketing_business_development;
      if (typeofBD === "string" || typeofBD === "object") {
        setMarketingBD(
          typeofBD === "object"
            ? response?.marketing_business_development
            : JSON.parse(response?.marketing_business_development)
        );
      }
    }
  }, []);
  const handlesumit = () => {
    let formData = new FormData();
    let newformState = { ...formState };
    delete newformState.property_customer_profile;
    delete newformState.property_type_data;
    newformState.marketing_assistance_information = JSON.stringify(marketingAI);
    newformState.marketing_business_development = JSON.stringify(marketingBD);
    newformState.business_development_marketing = JSON.stringify(
      newformState.business_development_marketing
    );
    Object.entries(newformState).map(([key, value]) => {
      if (!Array.isArray(value) && value != null) {
        formData.append(key, value);
      }
    });
    formData.append("property_id", property_id);
    newformState.amenity &&
      formData.append("amenity", JSON.stringify(newformState.amenity));
    formData.append(
      "competitor_property",
      JSON.stringify(newformState.competitor_property)
    );
    formData.append(
      "property_allocation",
      JSON.stringify(
        newformState.property_allocation.map((i) => {
          return {
            role_id: i.role_id,
            users: i.users,
          };
        })
      )
    );
    formData.append(
      "configuration_area",
      JSON.stringify(newformState.configuration_area)
    );
    newformState.insentive &&
      formData.append("insentive", JSON.stringify(newformState.insentive));
    newformState.property_image &&
      [...newformState.property_image].forEach((file) => {
        formData.append("property_image", file[0]);
      });

    dispatch(editProperty(formData));
  };
  useEffect(() => {
    seo({
      title: "Edit Property",
      metaDescription: "edit property details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.MarketingBD}
        url={"/property"}
        parentListing={strings.propertyListing}
        titleactive={strings.editProperty}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.MarketingAI}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.newspaper}
                      </label>
                      <textarea
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.newspaper}
                        name="newspaper"
                        value={marketingAI?.newspaper?.text}
                        onChange={(e) => {
                          const nextMarketingAI = {
                            ...marketingAI,
                            newspaper: {
                              ...marketingAI?.newspaper,
                              text: e.target.value,
                            },
                          };
                          setMarketingAI(nextMarketingAI);
                        }}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.fromdate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="start_date"
                          value={marketingAI?.newspaper?.start_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              newspaper: {
                                ...marketingAI?.newspaper,
                                start_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.toDate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="end_date"
                          value={marketingAI?.newspaper?.end_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              newspaper: {
                                ...marketingAI?.newspaper,
                                end_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.whatsappSMS}
                      </label>
                      <textarea
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.whatsappSMS}
                        name="whatsapp_sms"
                        value={marketingAI?.whatsapp_sms?.number}
                        onChange={(e) => {
                          const nextMarketingAI = {
                            ...marketingAI,
                            whatsapp_sms: {
                              ...marketingAI?.whatsapp_sms,
                              number: e.target.value,
                            },
                          };
                          setMarketingAI(nextMarketingAI);
                        }}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.fromdate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="start_date"
                          value={marketingAI?.whatsapp_sms?.start_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              whatsapp_sms: {
                                ...marketingAI?.whatsapp_sms,
                                start_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.toDate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="end_date"
                          value={marketingAI?.whatsapp_sms?.end_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              whatsapp_sms: {
                                ...marketingAI?.whatsapp_sms,
                                end_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.blastRadioJingles}
                      </label>
                      <textarea
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.blastRadioJingles}
                        name="blast_radio_jingles"
                        value={marketingAI?.blast_radio_jingles?.text}
                        onChange={(e) => {
                          const nextMarketingAI = {
                            ...marketingAI,
                            blast_radio_jingles: {
                              ...marketingAI?.blast_radio_jingles,
                              text: e.target.value,
                            },
                          };
                          setMarketingAI(nextMarketingAI);
                        }}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.fromdate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="start_date"
                          value={marketingAI?.blast_radio_jingles?.start_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              blast_radio_jingles: {
                                ...marketingAI?.blast_radio_jingles,
                                start_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.toDate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="end_date"
                          value={marketingAI?.blast_radio_jingles?.end_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              blast_radio_jingles: {
                                ...marketingAI?.blast_radio_jingles,
                                end_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mt-2 ">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.hoardings}
                      </label>
                      <textarea
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.hoardings}
                        name="hoardings"
                        value={marketingAI?.hoardings?.text}
                        onChange={(e) => {
                          const nextMarketingAI = {
                            ...marketingAI,
                            hoardings: {
                              ...marketingAI?.hoardings,
                              text: e.target.value,
                            },
                          };
                          setMarketingAI(nextMarketingAI);
                        }}
                        autoComplete="off"
                      />
                    </div>

                    <div className="col-md-4 mt-2">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.fromdate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="start_date"
                          value={marketingAI?.hoardings?.start_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              hoardings: {
                                ...marketingAI?.hoardings,
                                start_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mt-2">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.toDate}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="date"
                          name="end_date"
                          value={marketingAI?.hoardings?.end_date}
                          onChange={(e) => {
                            const nextMarketingAI = {
                              ...marketingAI,
                              hoardings: {
                                ...marketingAI?.hoardings,
                                end_date: e.target.value,
                              },
                            };
                            setMarketingAI(nextMarketingAI);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-8 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.digitalMarketing}
                      </label>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <label className="d-block pr-3" htmlFor="chk-ani">
                          <input
                            disabled
                            className="checkbox_animated"
                            id="chk-ani"
                            type="checkbox"
                            name="digital_marketing_google"
                            checked={
                              Number(
                                marketingAI?.digital_marketing
                                  ?.digital_marketing_google
                              ) === 1
                                ? true
                                : false
                            }
                            onChange={handledigitalmarketing}
                          />{" "}
                          {strings.google}
                        </label>
                        <label className="d-block pr-3" htmlFor="chk-ani1">
                          <input
                            disabled
                            className="checkbox_animated"
                            id="chk-ani1"
                            type="checkbox"
                            name="digital_marketing_facebook"
                            checked={
                              Number(
                                marketingAI?.digital_marketing
                                  ?.digital_marketing_facebook
                              ) === 1
                                ? true
                                : false
                            }
                            onChange={handledigitalmarketing}
                          />{" "}
                          {strings.facebook}
                        </label>
                        <label className="d-block pr-3" htmlFor="chk-ani2">
                          <input
                            disabled
                            className="checkbox_animated"
                            id="chk-ani2"
                            type="checkbox"
                            name="digital_marketing_instagram"
                            checked={
                              Number(
                                marketingAI?.digital_marketing
                                  ?.digital_marketing_instagram
                              ) === 1
                                ? true
                                : false
                            }
                            onChange={handledigitalmarketing}
                          />{" "}
                          {strings.instagram}
                        </label>
                        <label className="d-block pr-3" htmlFor="chk-ani2">
                          <input
                            disabled
                            className="checkbox_animated"
                            id="chk-ani2"
                            type="checkbox"
                            name="digital_marketing_taboola"
                            checked={
                              Number(
                                marketingAI?.digital_marketing
                                  ?.digital_marketing_taboola
                              ) === 1
                                ? true
                                : false
                            }
                            onChange={handledigitalmarketing}
                          />{" "}
                          {strings.taboola}
                        </label>
                        <label className="d-block " htmlFor="chk-ani3">
                          <input
                            disabled
                            className="checkbox_animated"
                            id="chk-ani3"
                            type="checkbox"
                            name="digital_marketing_timeSquare"
                            checked={
                              Number(
                                marketingAI?.digital_marketing
                                  ?.digital_marketing_timeSquare
                              ) === 1
                                ? true
                                : false
                            }
                            onChange={handledigitalmarketing}
                          />{" "}
                          {strings.timesquare}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-header pb-0">
                  <h5>{strings.MarketingBD}</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.residentLocation}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.residentLocation}
                        name="resident_location"
                        value={marketingBD?.resident_location}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.officeLocation}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.officeLocation}
                        name="office_location"
                        value={marketingBD?.office_location}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.occupation}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.occupation}
                        name="occupation"
                        value={marketingBD?.occupation}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.customerDesignation}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.customerDesignation}
                        name="customer_designation"
                        value={marketingBD?.customer_designation}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.AnnualIncome}
                      </label>
                      <Input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="number"
                        isNumber={true}
                        placeholder={strings.AnnualIncome}
                        name="annual_income"
                        value={marketingBD?.annual_income}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 10) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.ethnicity}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.ethnicity}
                        name="ethnicity"
                        value={marketingBD?.ethnicity}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.ageGroup}
                      </label>
                      <Input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="number"
                        isNumber={true}
                        placeholder={strings.ageGroup}
                        name="age_group"
                        value={marketingBD?.age_group}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 3) {
                            e.preventDefault();
                          }
                        }}

                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.rentedOwned}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.rentedOwned}
                        name="rented_owned"
                        value={marketingBD?.rented_owned}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.currentStayConfiguration}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.currentStayConfiguration}
                        name="current_stay_configuration"
                        value={marketingBD?.current_stay_configuration}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.customerBudget}
                      </label>
                      <Input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="number"
                        isNumber={true}
                        placeholder={strings.customerBudget}
                        name="customer_budget"
                        value={marketingBD?.customer_budget}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          if (e.target.value.length >= 10) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.preferredTypology}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.preferredTypology}
                        name="preferred_typology"
                        value={marketingBD?.preferred_typology}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.purposeofPurchase}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="text"
                        placeholder={strings.purposeofPurchase}
                        name="purpose_of_purchase"
                        value={marketingBD?.purpose_of_purchase}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label htmlFor="exampleFormControlFirstName">
                        {strings.possessionexpected}
                      </label>
                      <input
                        disabled
                        className="form-control"
                        id="exampleFormControlFirstName"
                        type="date"
                        placeholder={strings.possessionexpected}
                        name="possessionexpected"
                        value={marketingBD?.possessionexpected}
                        onChange={handleInputFieldBDS}
                        autoComplete="off"
                        min={moment().add(1, "days").format("yyyy-MM-DD")}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <Button
                        className="btn btn-color"
                        type="Button"
                        onClick={() => handlesumit()}
                        label={strings.update}
                      ></Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditPropertyStepFourth;
